module.exports = __webpack_public_path__ + "bradavice_5_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/bradavice_5_before.jpg
// module id = 938
// module chunks = 0